/* ============================================================================
   Redefinição do ID de administrador (via link enviado por e-mail).
   ============================================================================ */
import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { API_CONFIG } from '../../config/api';
import { toast, ToastHost } from '../components/Toast';
import { CoffeeLogo, IconWarning, IconKey } from '../components/icons';
import './Login.css';

const MIN_LEN = 16;

export default function ResetAdmin() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get('token');

  const [newId, setNewId] = useState('');
  const [confirmId, setConfirmId] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (newId !== confirmId) { setError('Os IDs não coincidem.'); return; }
    if (newId.length < MIN_LEN) { setError(`O ID deve ter no mínimo ${MIN_LEN} caracteres.`); return; }

    setLoading(true);
    try {
      const res = await fetch(`${API_CONFIG.BASE_URL}/admin/recover`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', 'X-API-Key': API_CONFIG.API_KEY },
        body: JSON.stringify({ token, newAdminId: newId }),
      });
      const data = await res.json();
      if (!data.success) throw new Error(data.message || 'Erro ao redefinir o ID.');
      toast.success('Admin ID atualizado. Use o novo ID para entrar.');
      setTimeout(() => navigate('/treinamentos/manager'), 1400);
    } catch (err) {
      setError(err.message || 'Erro ao redefinir o ID.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mg-auth">
      <div className="mg-auth-card">
        <div className="mg-auth-head">
          <span className="mg-auth-logo"><CoffeeLogo size={64} id="reset" /></span>
          <h1>Redefinir Admin ID</h1>
          <p>Defina um novo ID seguro</p>
        </div>

        {error && <div className="mg-auth-error">{error}</div>}

        {!token ? (
          <div className="mg-auth-body">
            <p className="mg-auth-text">Link inválido ou expirado.</p>
            <button className="mg-btn mg-btn-primary mg-btn-block" onClick={() => navigate('/treinamentos/manager')}>Voltar ao login</button>
          </div>
        ) : (
          <form className="mg-auth-body" onSubmit={handleSubmit}>
            <div className="mg-field">
              <label className="mg-label">Novo Admin ID</label>
              <div className="mg-auth-input-icon">
                <IconKey size={17} />
                <input className="mg-input" type="text" value={newId} onChange={(e) => setNewId(e.target.value)} placeholder={`Mínimo ${MIN_LEN} caracteres`} minLength={MIN_LEN} required disabled={loading} />
              </div>
            </div>
            <div className="mg-field">
              <label className="mg-label">Confirmar Admin ID</label>
              <div className="mg-auth-input-icon">
                <IconKey size={17} />
                <input className="mg-input" type="text" value={confirmId} onChange={(e) => setConfirmId(e.target.value)} placeholder="Digite novamente" minLength={MIN_LEN} required disabled={loading} />
              </div>
            </div>

            <div className="reset-warn">
              <IconWarning size={16} />
              <div>
                <strong>Atenção</strong>
                <span>Guarde o novo ID com segurança e atualize o deploy. O ID antigo deixará de funcionar.</span>
              </div>
            </div>

            <button type="submit" className="mg-btn mg-btn-primary mg-btn-block" disabled={loading}>
              {loading ? 'Redefinindo…' : 'Redefinir ID'}
            </button>
            <div className="mg-auth-links" style={{ justifyContent: 'center' }}>
              <button type="button" className="mg-auth-link" onClick={() => navigate('/treinamentos/manager')} disabled={loading}>Cancelar</button>
            </div>
          </form>
        )}
      </div>
      <ToastHost />
    </div>
  );
}
